import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import {
	PRICING_ARCHITECTURE_FRAGMENT,
	PRICING_ROOM_FRAGMENT, PRICING_SUBMISSION_FRAGMENT,
} from '@app/model/pricing-automation/service/PricingAutomationGraphQLFragments';

export const FIND_COMPANY_HOTEL_NOT_ASSIGNED_PRICING_ROOMS_QUERY: GraphQL = {
	name: 'findCompanyHotelNotAssignedPricingRooms',
	gql: gql`
      ${PRICING_ROOM_FRAGMENT}
      query findCompanyHotelNotAssignedPricingRooms($companyHotelId: Long!) {
          findCompanyHotelNotAssignedPricingRooms(companyHotelId: $companyHotelId) {
              ...PricingRoomFragment
          }
      }
	`,
};

export const FIND_COMPANY_HOTEL_PRICING_ROOMS_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingRooms',
	gql: gql`
      ${PRICING_ROOM_FRAGMENT}
      query findCompanyHotelPricingRooms($companyHotelId: Long!) {
          findCompanyHotelPricingRooms(companyHotelId: $companyHotelId) {
              ...PricingRoomFragment
          }
      }
	`,
};


export const FIND_COMPANY_HOTEL_PRICING_ARCHITECTURES_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingArchitectures',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      query findCompanyHotelPricingArchitectures($companyHotelId: Long!) {
          findCompanyHotelPricingArchitectures(companyHotelId: $companyHotelId) {
              ...PricingArchitectureFragment
          }
      }
	`,
};


export const FIND_COMPANY_HOTEL_PRICING_ARCHITECTURE_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingArchitecture',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      query findCompanyHotelPricingArchitecture($companyHotelId: Long!, $architectureId: Long!) {
          findCompanyHotelPricingArchitecture(companyHotelId: $companyHotelId, architectureId: $architectureId) {
              ...PricingArchitectureFragment
          }
      }
	`,
};


export const CREATE_COMPANY_HOTEL_PRICING_ARCHITECTURE_MUTATION: GraphQL = {
	name: 'createPricingArchitecture',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation createPricingArchitecture($companyHotelId: Long!, $pricingRoomId: Long!, $competitorsMappingType: HotelRoomMappingType!) {
          createPricingArchitecture(companyHotelId: $companyHotelId, pricingRoomId: $pricingRoomId, competitorsMappingType: $competitorsMappingType) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const CREATE_COMPANY_HOTEL_PRICING_ARCHITECTURE_DERIVATIVE_MUTATION: GraphQL = {
	name: 'createPricingArchitectureDerivative',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation createPricingArchitectureDerivative($input: CreatePricingArchitectureDerivativeInput!) {
          createPricingArchitectureDerivative(input: $input) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const EDIT_COMPANY_HOTEL_PRICING_ARCHITECTURE_DERIVATIVE_MUTATION: GraphQL = {
	name: 'editPricingArchitectureDerivative',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation editPricingArchitectureDerivative($input: EditPricingArchitectureDerivativeInput!) {
          editPricingArchitectureDerivative(input: $input) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const REMOVE_PRICING_ARCHITECTURE_MUTATION: GraphQL = {
	name: 'removePricingArchitecture',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation removePricingArchitecture($companyHotelId: Long!, $architectureId: Long!) {
          removePricingArchitecture(companyHotelId: $companyHotelId, architectureId: $architectureId) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const REMOVE_PRICING_ARCHITECTURE_DERIVATIVE_MUTATION: GraphQL = {
	name: 'removePricingArchitectureDerivative',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation removePricingArchitectureDerivative($companyHotelId: Long!, $architectureId: Long!, $derivativeId: Long!) {
          removePricingArchitectureDerivative(companyHotelId: $companyHotelId, architectureId: $architectureId, derivativeId: $derivativeId) {
              ...PricingArchitectureFragment
          }
      }
	`,
};



export const SAVE_PRICING_STRATEGY_MUTATION: GraphQL = {
	name: 'savePricingStrategy',
	gql: gql`
      ${PRICING_ARCHITECTURE_FRAGMENT}
      mutation savePricingStrategy($input: PricingStrategyInput!) {
          savePricingStrategy(input: $input) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const SUBMIT_PRICING_MUTATION: GraphQL = {
	name: 'submitPricing',
	gql: gql`
      mutation submitPricing($companyHotelId: Long!, $input: PricingIntegrationInput!) {
          submitPricing(companyHotelId: $companyHotelId, input: $input) {
			  errorCode
			  errorParams
			  errorMessage
			  state
			  blockedItems {
				  statDate
				  roomId
				  roomName
				  currentPrice
				  submittedPrice
				  latestProviderPrice
				  differencePercentage
				  limitPercentage
				  errorCode
			  }
          }
      }
	`,
};

export const SUBMIT_MANUAL_PRICING_MUTATION: GraphQL = {
	name: 'submitManualPricing',
	gql: gql`
      mutation submitManualPricing($companyHotelId: Long!, $input: ManualPricingIntegrationInput!) {
          submitManualPricing(companyHotelId: $companyHotelId, input: $input) {
              exception
              success
          }
      }
	`,
};

export const SUBMIT_MONTHLY_PRICING_MUTATION: GraphQL = {
	name: 'submitMonthlyPricing',
	gql: gql`
      mutation submitMonthlyPricing($companyHotelId: Long!, $month:Month!, $year:Int!) {
          submitMonthlyPricing(companyHotelId: $companyHotelId, month: $month, year: $year) {
			  errorCode
			  errorParams
              errorMessage
              state
			  blockedItems {
				  statDate
				  roomId
				  roomName
				  currentPrice
				  submittedPrice
				  latestProviderPrice
				  differencePercentage
				  limitPercentage
				  errorCode
			  }
          }
      }
	`,
};

export const SUBMIT_SELECTIVE_PRICING_MUTATION: GraphQL = {
	name: 'submitSelectivePricing',
	gql: gql`
      mutation submitSelectivePricing($companyHotelId: Long!, $input: SubmitSelectivePricingInput!) {
          submitSelectivePricing(companyHotelId: $companyHotelId, input: $input) {
			  errorCode
			  errorParams
              errorMessage
              state
			  blockedItems {
				  statDate
				  roomId
				  roomName
				  currentPrice
				  submittedPrice
				  latestProviderPrice
				  differencePercentage
				  limitPercentage
				  errorCode
			  }
          }
      }
	`,
};

export const SUBMIT_BULK_MANUAL_PRICING_MUTATION: GraphQL = {
	name: 'submitBulkManualPricing',
	gql: gql`
      mutation submitBulkManualPricing($companyHotelId: Long!, $input: BulkManualPricingInput!) {
          submitBulkManualPricing(companyHotelId: $companyHotelId, input: $input) {
			  state
			  errorCode
			  failures {
				  statDate
				  reasonCode
			  }
		  }
      }
	`,
};

export const FIND_COMPANY_HOTEL_PRICING_STRATEGY_COMPETITORS_IMPORTANCE_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingStrategyCompetitorImportances',
	gql: gql`
      query findCompanyHotelPricingStrategyCompetitorImportances($companyHotelId: Long!) {
          findCompanyHotelPricingStrategyCompetitorImportances(companyHotelId: $companyHotelId) {
              competitorId
              importance
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_PRICING_STRATEGY_COMPETITORS_IMPORTANCE_MUTATION: GraphQL = {
	name: 'savePricingStrategyCompetitorImportance',
	gql: gql`
      mutation savePricingStrategyCompetitorImportance($input: PricingStrategyCompetitorsImportanceInput!) {
          savePricingStrategyCompetitorImportance(input: $input) {
              competitorId
              importance
          }
      }
	`,
};

export const CREATE_PRICE_RECOMMENDATION_FEEDBACK_MUTATION: GraphQL = {
	name: 'createPricingRecommendationFeedback',
	gql: gql`
      mutation createPricingRecommendationFeedback($input: PriceRecommendationFeedbackInput!) {
          createPriceRecommendationFeedback(input: $input) {
              exception
              success
          }
      }
	`,
};


export const SWITCH_PRICING_ARCHITECTURE_ORDER_INDEX_MUTATION: GraphQL = {
	name: 'switchPricingArchitectureOrderIndex',
	gql: gql`
			${PRICING_ARCHITECTURE_FRAGMENT}
      mutation switchPricingArchitectureOrderIndex($companyHotelId: Long!, $architectureId: Long!, $orderIndex: Int!) {
          switchPricingArchitectureOrderIndex(companyHotelId: $companyHotelId, architectureId: $architectureId, orderIndex: $orderIndex) {
              ...PricingArchitectureFragment
          }
      }
	`,
};

export const FIND_COMPANY_HOTEL_BOOKING_PACE_QUERY: GraphQL = {
	name: 'findCompanyHotelBookingPace',
	gql: gql`
      query findCompanyHotelBookingPace($companyHotelId: Long!, $marketStatePromptId: Long!) {
          findCompanyHotelBookingPace(companyHotelId: $companyHotelId, marketStatePromptId: $marketStatePromptId) {
              availabilities {
                  roomMappingType
                  totalRoomCapacity
                  availability {
                      availableRoomsToday
                      availableRooms1dAgo
                      availableRooms2dAgo
                      availableRooms3dAgo
                      availableRooms5dAgo
                      availableRooms7dAgo
                      availableRooms10dAgo
                      availableRooms15dAgo
                      availableRooms30dAgo
                      availableRooms45dAgo
                      availableRooms60dAgo
                  }
                  isTotal
              }
          }
      }
	`,
};

// The Pickup of every stay date of one month (new query of the ticket): per date, the availability totals
// of the stored prompt of the latest valid recommendation, the same numbers as findCompanyHotelBookingPace.
export const FIND_COMPANY_HOTEL_BOOKING_PACE_FOR_PERIOD_QUERY: GraphQL = {
	name: 'findCompanyHotelBookingPaceForPeriod',
	gql: gql`
      query findCompanyHotelBookingPaceForPeriod($companyHotelId: Long!, $year: Int!, $month: Month!) {
          findCompanyHotelBookingPaceForPeriod(companyHotelId: $companyHotelId, year: $year, month: $month) {
              statDate
              availabilities {
                  roomMappingType
                  totalRoomCapacity
                  availability {
                      availableRoomsToday
                      availableRooms1dAgo
                      availableRooms2dAgo
                      availableRooms3dAgo
                      availableRooms5dAgo
                      availableRooms7dAgo
                      availableRooms10dAgo
                      availableRooms15dAgo
                      availableRooms30dAgo
                      availableRooms45dAgo
                      availableRooms60dAgo
                  }
                  isTotal
              }
          }
      }
	`,
};

export const PAGE_COMPANY_HOTEL_PRICING_SUBMISSIONS_QUERY: GraphQL = {
	name: 'pageCompanyHotelPricingSubmissions',
	gql: gql`
      ${PRICING_SUBMISSION_FRAGMENT}
      query pageCompanyHotelPricingSubmissions($companyHotelId: Long!, $pageRequest: PageRequestInput!) {
          pageCompanyHotelPricingSubmissions(companyHotelId: $companyHotelId, pageRequest: $pageRequest) {
              content {
                  ...PricingSubmissionFragment
              }
              totalElements
              isEmpty
              isLastPage
              request {
                  sort {
                      field
                      direction
                  }
                  size
                  page
              }
          }
      }
	`
}

export const FIND_COMPANY_HOTEL_PRICING_SUBMISSION_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingSubmission',
	gql: gql`
      ${PRICING_SUBMISSION_FRAGMENT}
      query findCompanyHotelPricingSubmission($companyHotelId: Long!, $submissionId: Long!) {
          findCompanyHotelPricingSubmission(companyHotelId: $companyHotelId, submissionId: $submissionId) {
              ...PricingSubmissionFragment
          }
      }
	`
}

export const FIND_COMPANY_HOTEL_PRICING_SUBMISSIONS_FOR_STAT_DATE_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingSubmissionsForStatDate',
	gql: gql`
      ${PRICING_SUBMISSION_FRAGMENT}
      query findCompanyHotelPricingSubmissionsForStatDate($companyHotelId: Long!, $statDate: LocalDate!) {
          findCompanyHotelPricingSubmissionsForStatDate(companyHotelId: $companyHotelId, statDate: $statDate) {
              ...PricingSubmissionFragment
          }
      }
	`
}

export const FIND_COMPANY_HOTEL_PRICE_CHANGES_FOR_STAT_DATE_QUERY: GraphQL = {
	name: 'findCompanyHotelPriceChangesForStatDate',
	gql: gql`
      query findCompanyHotelPriceChangesForStatDate($companyHotelId: Long!, $statDate: LocalDate!, $fromDate: LocalDate!) {
          findCompanyHotelPriceChangesForStatDate(companyHotelId: $companyHotelId, statDate: $statDate, fromDate: $fromDate) {
              submissionId
              finishDate
              profileName
              items {
                  pricingArchitectureRoomId
                  roomName
                  previousPrice
                  price
                  isChange
              }
          }
      }
	`,
};

export const FIND_COMPANY_HOTEL_PRICING_ROOMS_WITH_PRICE_QUERY: GraphQL = {
	name: 'findCompanyHotelPricingRoomWithPrice',
	gql: gql`
      ${PRICING_ROOM_FRAGMENT}
      query findCompanyHotelPricingRoomWithPrice($companyHotelId: Long!, $statDate: LocalDate!)   {
          findCompanyHotelPricingRoomWithPrice(companyHotelId: $companyHotelId, statDate: $statDate) {
              architectureId
              roomMappingType
              isAnchor
              room {
                  ...PricingRoomFragment
              }
              price
              derivativeRule {
                  type
                  value
              }
          }

      }
	`
}
